export default __webpack_public_path__ + "static/media/EDISON_MC-DS-release3-v04.bb6ceb5b.pdf";